import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tiêu đề kế hoạch:")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tháng:")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold required" }, " Danh mục toa xe: ", -1)
const _hoisted_4 = { class: "text-danger" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold required" }, " Cấp sửa chữa: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, " Ghi chú: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createBlock(_component_PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa'), 1)
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.BACK,
        onClick: _ctx.goBack
      }, null, 8, ["button-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        onSubmit: _withModifiers(() => {}, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _hoisted_1
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_form_item, {
                class: "mb-0",
                prop: "ten_ke_hoach"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.ten_ke_hoach,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.ten_ke_hoach) = $event)),
                    name: "ten_ke_hoach",
                    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            "col-3": _withCtx(() => [
              _hoisted_2
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.thang,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.thang) = $event)),
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
                    return _createVNode(_component_el_option, {
                      key: month,
                      value: month,
                      label: 'Tháng ' + month
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Tháng " + _toDisplayString(month), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _createVNode(_component_LabelCustom, { "is-required": true }, {
                default: _withCtx(() => [
                  _createTextVNode("Số lượng toa xe")
                ]),
                _: 1
              })
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.form.so_luong_toa_xe,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.so_luong_toa_xe) = $event)),
                class: "w-100",
                min: 0,
                name: "so_luong_toa_xe",
                "controls-position": "right",
                onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select()))
              }, null, 8, ["modelValue"])
            ]),
            "col-3": _withCtx(() => [
              _hoisted_3
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_autocomplete, {
                modelValue: _ctx.tenDanhMucToaXe,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tenDanhMucToaXe) = $event)),
                ref: "danhMucToaXeInput",
                class: "w-100",
                clearable: "",
                placeholder: "Tìm kiếm DMTX",
                "value-key": "ten_danh_muc",
                "trigger-on-focus": false,
                "fetch-suggestions": _ctx.queryDanhMucToaXe,
                "highlight-first-item": true,
                onSelect: _ctx.onSelectDanhMucToaXe,
                onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
              }, {
                default: _withCtx(({ item }) => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(item.ma_danh_muc) + " - ", 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.ten_danh_muc), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "fetch-suggestions", "onSelect"]),
              _withDirectives(_createElementVNode("span", _hoisted_4, " Không có dữ liệu ", 512), [
                [_vShow, !_ctx.isDanhMucItemsAvailable]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ResponsiveLayout, null, {
            "col-1": _withCtx(() => [
              _hoisted_5
            ]),
            "col-2": _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.capSuaChuaId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.capSuaChuaId) = $event)),
                class: "w-100",
                placeholder: "Chọn danh mục"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Chưa chọn",
                    value: 0
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capSuaChuaItems, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.id,
                      label: item.ten_cap_sc
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            "col-3": _withCtx(() => [
              _hoisted_6
            ]),
            "col-4": _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.ghi_chu,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.ghi_chu) = $event)),
                type: "textarea",
                rows: 3
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DivRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_DivCol, { cols: 10 }),
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex justify-content-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.SAVE,
                    "color-type": _ctx.ButtonTypeColors.SUCCESS,
                    onClick: _ctx.submit
                  }, null, 8, ["button-type", "color-type", "onClick"]),
                  _createVNode(_component_ButtonCustom, {
                    "color-type": _ctx.ButtonTypeColors.DANGER,
                    "button-type": _ctx.ButtonsType.TRASH,
                    onClick: _ctx.clear
                  }, null, 8, ["color-type", "button-type", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}